module.exports = __webpack_public_path__ + "img/sentaosa-logo.293f5278.png";